export default "__VITE_ASSET__770ba3f3__"